import React, { cloneElement, isValidElement, useState } from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';

import type { TileProps } from '../../tile.props';

import classes from './tile-header.module.scss';

interface TileHeaderProps {
  activeSliderIndx: number;
  title: TileProps['title'];
  titleIcon: TileProps['titleIcon'];
  titleLink?: string;

  onTitleClick?: TileProps['onTitleClick'];
}

const TileHeader = ({ title, titleIcon, titleLink, onTitleClick, activeSliderIndx }: TileHeaderProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const renderTitleIcon = (icon: React.ReactNode) => {
    if (isValidElement<{ hovered?: boolean }>(icon) && typeof icon.type !== 'string') {
      return cloneElement(icon, { hovered: isHovered });
    }
    return icon;
  };

  const handleTitleClick = () => {
    if (!onTitleClick) return;

    if (Array.isArray(onTitleClick)) {
      const handler = onTitleClick[activeSliderIndx];
      if (handler) handler();
    } else {
      onTitleClick();
    }
  };

  const displayTitle = Array.isArray(title) ? title[activeSliderIndx] : title;
  const displayIcon = Array.isArray(titleIcon)
    ? renderTitleIcon(titleIcon[activeSliderIndx])
    : renderTitleIcon(titleIcon);

  return (
    <div className={classes.header}>
      <div
        className={cn(classes.title_container, onTitleClick && 'pointer')}
        onClick={handleTitleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {titleLink ? (
          <Link to={titleLink} className='d-flex a-i-center'>
            {displayIcon}
            <span className={classes.title}>{displayTitle}</span>
          </Link>
        ) : (
          <>
            {displayIcon}
            <span className={classes.title}>{displayTitle}</span>
          </>
        )}
      </div>
    </div>
  );
};

export default TileHeader;
